//smt menu
jQuery(function($){
    $('.menu').on('click',function(){
        $('.menu__line').toggleClass('active');
        $('.gnav').fadeToggle();
    });
});

jQuery(function($){
    $('.left_area').on('click',function(){
        $('.menu__line').toggleClass('active');
        $('.gnav').fadeToggle();
    });
});

jQuery(function($){
$('li.gnav__menu__item a[href^="#"]').on('click', function() {
    $('.menu').click();
    return false;
  });
});

// smooth scroll
$(function () {
  $('a[href*="#"]').click(function () {
    const speed = 400;
    const target = $(this.hash === '#' || '' ? 'html' : this.hash)
    if (!target.length) return;
    const targetPos = target.offset().top;
    $('html, body').animate({ scrollTop: targetPos }, speed, 'swing');
    return false;
  });
});

// scroll position1
$(window).on('load', function() {
var url = $(location).attr('href');
if(url.indexOf("#") != -1){
var anchor = url.split("#");
var target = $('#' + anchor[anchor.length - 1]);
if(target.length){
var pos = Math.floor(target.offset().top) - 100;
$("html, body").animate({scrollTop:pos}, 500);
}
}
});

// scroll position2
$(window).on('load', function() {
var headerHight = 140;
$('a[href^="#"]').click(function(){
    var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
       var position = target.offset().top-headerHight;
    $("html, body").animate({scrollTop:position}, 550, "swing");
       return false;
  });
});